export const getSavePackageString = (str: string) => {
  const ans =  str.split("").reduce((el, acc, idx) => {
    return acc + ([2, 4, 6].includes(idx) ? ` ${el}` : el)}, "")

  return ans;
}